import { render, staticRenderFns } from "./sto.vue?vue&type=template&id=67ffd944&"
import script from "./sto.vue?vue&type=script&lang=js&"
export * from "./sto.vue?vue&type=script&lang=js&"
import style0 from "./sto.vue?vue&type=style&index=0&id=67ffd944&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports